// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@vanmeter/XDL/types";

export default {
    primary: {
        main: "#00214A",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#E9B22D",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#B0AEAE",
        disabled: "#CCCCCC",
        // XNG-Changes
        ui1: "#FFFFFF",
        ui2: "#F6F6F6",
        ui3: "#B0AEAE",
        ui4: "#868686",
        ui5: "#5D5D5D",
        ui6: "#3B3B3B",
        ui7: "#0C0908",
        ui8: "#CD4A23",
        ui9: "#28343C",
        ui10: "#565F65",
        ui11: "#EDE4C5",
        ui12: "#E5E5DB",
        ui13: "#989A87",
        ui14: "#F6F6F0",
        ui15: "#04397C",
        ui16: "#001631",
        ui17: "#FEC742",
        ui18: "#A37C1E",
        ui19: "#DC3300",
        ui20: "#962D0E",
        ui21: "#EEEEEE",
        white: "#FFFFFF",
        black: "#0C0908",
    },
    text: {
        main: "#3B3B3B",
        disabled: "#475353",
        accent: "#FF0000",
        link: "#00214A",
    },
    success: {
        main: "#28A745",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#EA0909",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#095D8B",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
